import app from "../_app";

function volumeDiscountsInit() {
    const discounts = document.querySelector('.planet-volume-layout');

    if (discounts) {
        console.log('22222');

        const discountItems = [...discounts.querySelectorAll('.planet-volume-volumeItem')];
        discountItems.map(discountItem => {
            discountItem.addEventListener('click', (e) => {
                const quantityText = discountItem.querySelector('.planet-volume-label').innerText;
                const quantityNumber = parseInt(quantityText.match(/(\d+)/)[1]);
                const select = document.querySelector('.js-pdp-order-desktop').querySelector('.js-order-select');

                select.value = quantityNumber;
            })
        });
    }

}


if (app.viewport.isEqualOrGreaterThan('lg')) {

    window.addEventListener('DOMContentLoaded', () => {
        const element = document.querySelector('.planet-volume-layout');
        const desktopTarget = document.querySelector('.js-pdp-order-desktop');

        if(desktopTarget) {
            const form = desktopTarget.querySelector('.js-product-form');

            if (form) {
                form.parentNode.insertBefore(element, form);
                volumeDiscountsInit();
            }
        }
    });

}else {
    volumeDiscountsInit();
}
